document.addEventListener("DOMContentLoaded", function () {
  if (!window.location.pathname.includes("cart")) {
    console.warn("🚫 ShippingBar wordt niet geladen, want we zijn niet op de winkelwagenpagina.");
    return;
  }

  const freeShippingThreshold = 70; // Gratis verzending vanaf €70
  const shippingBar = document.getElementById("free-shipping-bar");

  if (!shippingBar) {
    console.warn("⚠️ free-shipping-bar niet gevonden op deze pagina.");
    return;
  }

  function updateFreeShippingBar() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const subtotal = cart.items_subtotal_price / 100;
        console.log("🛒 Subtotaal bijgewerkt:", subtotal);

        if (subtotal >= freeShippingThreshold) {
          shippingBar.innerHTML = "<span class='congratulations-message'><strong>Gefeliciteerd! Je hebt <span class='highlight-gratis'>gratis</span> verzending!</strong></span>";
          shippingBar.classList.add("green-background");
        } else {
          const remaining = (freeShippingThreshold - subtotal).toFixed(2).replace(".", ",");
          shippingBar.innerHTML = `Bestel voor nog <strong class="highlighted-amount">€${remaining}</strong> om in aanmerking te komen voor <span class="highlighted-text">gratis verzending!</span>`;
          shippingBar.classList.remove("green-background");
        }

        shippingBar.style.display = "block";
      })
      .catch((error) => console.error("❌ Fout bij het ophalen van de winkelwagen:", error));
  }

  // ✅ Shopify AJAX Cart Observer
  function observeShopifyCart() {
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      return originalFetch.apply(this, args).then(response => {
        if (args[0].includes('/cart/change.js') || args[0].includes('/cart/update.js') || args[0].includes('/cart/add.js')) {
          console.log("🔄 Shopify winkelwagen gewijzigd, bar bijwerken...");
          setTimeout(updateFreeShippingBar, 500);
        }
        return response;
      });
    };
  }

  // ✅ Start de observer en update de bar direct bij laden
  observeShopifyCart();
  updateFreeShippingBar();
});
